
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ConvertCurrencyService {
  constructor() { }

  public convertToVietnamText(money: string, currency?: string): string {
    const language = localStorage.getItem('__language');
    if (language === 'en') {
      return this.convertToEnglishText(money, currency);
    }
    const default_numbers = ' hai ba bốn năm sáu bảy tám chín';
    const units = ('1 một' + default_numbers).split(' ');
    const ch = 'lẻ mười' + default_numbers;
    const tr = 'không một' + default_numbers;
    const tram = tr.split(' ');
    const u = ['2', 'nghìn', 'triệu', 'tỷ', 'nghìn tỷ', 'triệu tỷ'];
    const chuc = ch.split(' ');
    function tenth(a): string {
      let sl1 = units[a[1]];
      const sl2 = chuc[a[0]];
      let append = '';
      if (a[0] > 0 && Number(a[1]) === 5) sl1 = 'lăm';
      if (a[0] > 1) {
        append = ' mươi';
        if (Number(a[1]) === 1) sl1 = ' mốt';
      }
      const str = sl2 + '' + append + ' ' + sl1;
      return str;
    }
    function block_of_three(d): string {
      const _a = d + '';
      if (d === '000') {
        return '';
      }
      switch (_a.length) {
        case 0:
          return '';
        case 1:
          return units[_a];
        case 2:
          return tenth(_a);
        case 3:
          let sl12 = '';
          if (_a.slice(1, 3) !== '00') sl12 = tenth(_a.slice(1, 3));
          const sl3 = tram[_a[0]] + ' trăm';
          return sl3 + ' ' + sl12;
      }
    }
    function to_vietnamese(str: string, currencyText?: string): string {
      const isNegative = str && typeof str === 'string' && str.substring(0,1) === '-' ? true : false;
      if (isNegative) {
        str = str.replace('-', '');
      }
      const arrNumber = str ? str.toString().split('.') : [];
      const text = Number(arrNumber[0] ? arrNumber[0] : null) + '';
      let i = 0;
      const arr = [];
      let index = text.length;
      const result = [];
      if (!str) {
        return '';
      }
      if (Number(str) === 0) {
        return currencyText ? 'không ' + currencyText : 'không';
      }
      if (index === 0 || text === 'NaN') {
        return '';
      }
      if (Number(str) >= 999999999999999999) {
        return 'Không đọc được số tiền này!';
      }
      let string = '';
      // explode number string into blocks of 3numbers and push to queue
      while (index >= 0) {
        arr.push(str.substring(index, Math.max(index - 3, 0)));
        index -= 3;
      }
      // loop though queue and convert each block
      for (i = arr.length - 1; i >= 0; i--) {
        if (arr[i] !== '' && arr[i] !== '000') {
          result.push(block_of_three(arr[i]));
          if (u[i]) result.push(u[i]);
        }
      }
      if (currencyText) {
        result.push(currencyText);
      }
      string = result.join(' ');
      // remove unwanted white space
      const newString = string.replace(/[0-9]/g, '').replace(/  /g, ' ').replace(/ $/, '').replace(/\s\s+/g, ' ');
      return isNegative ? 'âm ' + newString : newString;
    }
    const currencyString = to_vietnamese(money, currency);
    return currencyString
      ? currencyString.charAt(0).toUpperCase() + currencyString.slice(1)
      : '';
  }

  convertToEnglishText(money: string, currency?: string) {
    var bigNumArry = new Array('', ' Thousand', ' Million', ' Billion', ' Trillion', ' Quadrillion', ' Quintillion');

    var output = '';
    var numString = money;
    var finlOutPut = new Array();

    if (numString == '0') {
      return currency ? 'Zero ' + currency : 'Zero';
    }

    if (numString.length == 0) {
      return '';
    }

    if (Number(numString) > 999999999999999999) {
      return "Can't read this number!";
    }

    var i = numString.length;
    i = i - 1;

    //cut the number to grups of three digits and add them to the Arry
    while (numString.length > 3) {
      var triDig = new Array(3);
      triDig[2] = numString.charAt(numString.length - 1);
      triDig[1] = numString.charAt(numString.length - 2);
      triDig[0] = numString.charAt(numString.length - 3);

      var varToAdd = triDig[0] + triDig[1] + triDig[2];
      finlOutPut.push(varToAdd);
      i--;
      numString = numString.substring(0, numString.length - 3);
    }
    finlOutPut.push(numString);
    finlOutPut.reverse();

    //conver each grup of three digits to english word
    //if all digits are zero the triConvert
    //function return the string "dontAddBigSufix"
    for (let j = 0; j < finlOutPut.length; j++) {
      finlOutPut[j] = this.triConvert(parseInt(finlOutPut[j], 10));
    }

    var bigScalCntr = 0; //this int mark the million billion trillion... Arry

    for (let b = finlOutPut.length - 1; b >= 0; b--) {
      if (finlOutPut[b] != "dontAddBigSufix") {
        finlOutPut[b] = finlOutPut[b] + bigNumArry[bigScalCntr] + '';
        bigScalCntr++;
      } else {
        //replace the string at finlOP[b] from "dontAddBigSufix" to empty String.
        finlOutPut[b] = ' ';
        bigScalCntr++; //advance the counter  
      }
    }

    //convert The output Arry to , more printable string 
    for (let n = 0; n < finlOutPut.length; n++) {
      output += finlOutPut[n];
    }

    return currency ? output.trim() + ' ' + currency : output.trim(); //print the output
  }

  //simple function to convert from numbers to words from 1 to 999
  triConvert(num) {
    var ones = new Array('', ' One', ' Two', ' Three', ' Four', ' Five', ' Six', ' Seven', ' Eight', ' Nine', ' Ten', ' Eleven', ' Twelve', ' Thirteen', ' Fourteen', ' Fifteen', ' Sixteen', ' Seventeen', ' Eighteen', ' Nineteen');
    var tens = new Array('', '', ' Twenty', ' Thirty', ' Forty', ' Fifty', ' Sixty', ' Seventy', ' Eighty', ' Ninety');
    var hundred = ' Hundred';
    var output = '';
    var numString = num.toString();

    if (num == 0) {
      return 'dontAddBigSufix';
    }
    //the case of 10, 11, 12 ,13, .... 19 
    if (num < 20) {
      output = ones[num];
      return output;
    }

    //100 and more
    if (numString.length == 3) {
      output = ones[parseInt(numString.charAt(0))] + hundred;
      if (ones[parseInt(numString.charAt(1) + numString.charAt(2))]) {
        output += ones[parseInt(numString.charAt(1) + numString.charAt(2))];
        return output;
      }

      output += tens[parseInt(numString.charAt(1))];
      output += ones[parseInt(numString.charAt(2))];
      return output;
    }

    output += tens[parseInt(numString.charAt(0))];
    output += ones[parseInt(numString.charAt(1))];

    return output;
  }
}